import { RoleTypes } from '../../utils/rolesTypes';
import { TableHead } from './types';

export const WORK_TIME_FULL_REPORT_HEAD_DATA: TableHead[] = [
  {
    label: 'TABLE_FILTER.LABEL.DATE',
    key: 'date',
    align: 'left',
    sortable: false,
    role: RoleTypes.RoleEmployee,
    width: '9%',
  },
  {
    label: 'TABLE.HEAD.STARTING_TIME',
    key: 'startTime',
    align: 'center',
    sortable: false,
    role: RoleTypes.RoleEmployee,
    width: '9%',
  },
  {
    label: 'TABLE.HEAD.ENDING_TIME',
    key: 'endTime',
    align: 'center',
    sortable: false,
    role: RoleTypes.RoleEmployee,
    width: '9%',
  },
  {
    label: 'TABLE.HEAD.BREAK_TIME',
    key: 'breakTime',
    align: 'center',
    sortable: false,
    role: RoleTypes.RoleEmployee,
    width: '6%',
  },
  {
    label: 'TABLE.HEAD.TOTAL_TIME',
    key: 'totalTime',
    align: 'center',
    sortable: false,
    role: RoleTypes.RoleEmployee,
    width: '8%',
  },
  {
    label: 'TABLE.HEAD.MULTIPLICATOR',
    key: 'multiplicator',
    align: 'center',
    sortable: false,
    role: RoleTypes.RoleEmployee,
    width: '7%',
  },
  {
    label: 'TABLE.HEAD.CLIENT',
    key: 'clientName',
    align: 'left',
    sortable: false,
    role: RoleTypes.RoleEmployee,
    width: '14%',
  },
  {
    label: 'TABLE.HEAD.PROJECT',
    key: 'projectName',
    align: 'left',
    sortable: false,
    role: RoleTypes.RoleEmployee,
    width: '14%',
  },
  {
    label: 'ORDER_PRESENTATION.WORK_ORDER',
    key: 'order',
    align: 'center',
    sortable: false,
    role: RoleTypes.RoleEmployee,
    width: '10%',
  },
  {
    label: 'TABLE.HEAD.COMMENT',
    key: 'projectName',
    align: 'left',
    sortable: false,
    role: RoleTypes.RoleEmployee,
    width: '18%',
  },
  {
    label: 'TABLE.HEAD.ACTION',
    key: 'action',
    align: 'center',
    sortable: false,
    role: RoleTypes.RoleEmployee,
    width: '7%',
  },
];

const CLOCK_TIME_COLUMNS = ['startTime', 'endTime', 'breakTime'];

export interface FullReportColumns {
  // The work order column is hidden while order reporting is OFF.
  showOrder?: boolean;
  // The multiplier column only matters when some entry is not 100%.
  showMultiplier?: boolean;
}

// Hours-only accounts see one "Working hours" input instead of the clock
// time columns and the computed total.
export const getFullReportHeadData = (
  hoursOnly: boolean,
  { showOrder = true, showMultiplier = true }: FullReportColumns = {},
): TableHead[] =>
  WORK_TIME_FULL_REPORT_HEAD_DATA.filter(
    ({ key }) =>
      !(hoursOnly && CLOCK_TIME_COLUMNS.includes(key)) &&
      (showOrder || key !== 'order') &&
      (showMultiplier || key !== 'multiplicator'),
  ).map((head) =>
    hoursOnly && head.key === 'totalTime'
      ? { ...head, label: 'TABLE.HEAD.WORKING_HOURS', width: '9%' }
      : head,
  );

// The footer has the counter cells (three for employment contracts, two for
// B2B and civil contracts), the reported and not-reported day counts, the
// settled note (when settled) and the action cell. Spare columns widen the
// not-reported and settled cells first; the rest is filler. With too few
// columns the settled note joins the not-reported cell.
export const getFullReportFooterSpans = (
  columns: number,
  settled: boolean,
  counterCells = 3,
) => {
  const settledInline = settled && columns < counterCells + 4;
  const fixed = counterCells + 3 + (settled && !settledInline ? 1 : 0);
  let spare = Math.max(0, columns - fixed);
  const notReported = 1 + Math.min(spare, 2);
  spare -= notReported - 1;
  const settledSpan = settled && !settledInline ? 1 + Math.min(spare, 1) : 0;
  spare -= Math.max(0, settledSpan - 1);
  return { notReported, settled: settledSpan, settledInline, filler: spare };
};
